module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/thunder-circle-7f55ff48c91f2d5f56fef7b45fafa0ca.svg";